<template>
    <div class="data-table-component">
        <div class="filters-section" v-if="this.filters" :key="filtersRefreshKey">
            <div v-for="filter of this.filters" :key="filter.key" class="filter-item">
                <select v-if="filter.type == 'select'" :name="filter.key" @change="filterChanged($event)">
                    <option value="">Choose {{ filter.key }} (RESET)</option>
                    <option v-for="(filterValue, filterKey) of filter.values" :key="filterKey" :value="filterKey">
                        {{ filterValue }}
                    </option>
                </select>
            </div>
            <a href="javascript:;" v-on:click="resetFiltersData()">Reset</a>
        </div>
        <div class="inner">
            <div v-if="isLoading" class="empty-datatable">
                Loading...
            </div>
            <table v-else-if="dataSet.length > 0" class="data-table" cellspacing="0">
                <thead>
                    <template v-for="(item, key) of columns">
                        <th :key="key" v-on:click="sortByColumn(key)" v-if="(key != '_id' || displayId) && !key.includes('token') && key !== 'referralNote' && key !== 'comments'">
                            <span class="th-inner" :class="sortable && !nonSortableColumns.includes(key) && 'sortable'">
                                <span v-html="item"></span>
                                <template v-if="sortable && !nonSortableColumns.includes(key)">
                                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_738_10319)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.95432 13.4955L2.97385 13.4925C2.97874 13.4917 2.98362 13.491 2.98851 13.4902C2.99414 13.4891 2.9994 13.4876 3.00504 13.4861L3.02232 13.4816C3.02646 13.4805 3.03059 13.4797 3.03472 13.4786C3.04036 13.4771 3.04599 13.4748 3.05125 13.4729L3.06628 13.4677C3.07079 13.4662 3.0753 13.4647 3.07981 13.4628C3.08469 13.4609 3.08958 13.4583 3.09408 13.456L3.10874 13.4489C3.11362 13.4466 3.11813 13.4444 3.12302 13.4421C3.12715 13.4399 3.13166 13.4373 3.13617 13.4342L3.15119 13.4252C3.15533 13.4226 3.15984 13.4203 3.16359 13.4177C3.16923 13.414 3.17449 13.4098 3.17975 13.4057L3.1944 13.3948C3.19703 13.3929 3.19929 13.3914 3.20192 13.3892C3.21507 13.3783 3.22709 13.3674 3.23799 13.3565L5.64261 10.9518C5.73504 10.8594 5.78576 10.7369 5.78576 10.6066C5.78576 10.4762 5.73504 10.3533 5.64261 10.2613C5.45212 10.0708 5.14215 10.0708 4.95203 10.2613L3.38114 11.8322V0.988439C3.38114 0.719046 3.16209 0.5 2.8927 0.5C2.6233 0.5 2.40426 0.719046 2.40426 0.988439V11.8322L0.833362 10.2613C0.738304 10.1662 0.613189 10.1185 0.488073 10.1185C0.362958 10.1185 0.237842 10.1662 0.142784 10.2613C0.0503563 10.3537 -0.000366211 10.4762 -0.000366211 10.6066C-0.000366211 10.7369 0.0503563 10.8598 0.142784 10.9518L2.54741 13.3565C2.5583 13.3674 2.57033 13.3783 2.58348 13.3888C2.58611 13.391 2.58874 13.3929 2.59174 13.3948L2.60715 13.4061C2.61203 13.4098 2.61729 13.4136 2.62255 13.4173C2.62631 13.42 2.63044 13.4222 2.63495 13.4249L2.65036 13.4342C2.65449 13.4369 2.65862 13.4395 2.66313 13.4418C2.66764 13.444 2.67252 13.4463 2.67703 13.4485L2.69169 13.4557C2.69657 13.4579 2.70108 13.4602 2.70596 13.4624C2.71047 13.4643 2.71461 13.4654 2.71874 13.4669L2.73489 13.4726C2.74053 13.4745 2.74579 13.4767 2.75143 13.4782C2.75556 13.4793 2.75932 13.4805 2.76345 13.4812L2.78036 13.4853C2.78599 13.4868 2.792 13.4884 2.79802 13.4895C2.8029 13.4902 2.80778 13.491 2.81267 13.4917L2.83296 13.4947C2.83709 13.4955 2.84085 13.4962 2.84498 13.4966C2.85963 13.4981 2.87429 13.4985 2.88856 13.4989H2.89345C2.89345 13.4989 2.89721 13.4989 2.89909 13.4989C2.91224 13.4989 2.92689 13.4981 2.94154 13.4966C2.94605 13.4962 2.95056 13.4955 2.95469 13.4947L2.95432 13.4955Z" fill="#313131"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8568 3.04766L10.4522 0.643038C10.4413 0.632142 10.4293 0.621246 10.4161 0.610726C10.4135 0.608471 10.4105 0.606217 10.4075 0.604338L10.3913 0.592315C10.3868 0.588934 10.3823 0.585552 10.3774 0.582171C10.3729 0.579165 10.368 0.576535 10.3635 0.573529L10.3481 0.564512C10.3444 0.562257 10.3402 0.559627 10.3365 0.557373C10.3316 0.554743 10.3267 0.552489 10.3218 0.550234L10.3064 0.543096C10.3019 0.540841 10.2974 0.538587 10.2929 0.536708C10.2884 0.53483 10.2835 0.533327 10.279 0.531448L10.2632 0.525812C10.2583 0.523934 10.2531 0.522055 10.2482 0.520552C10.2441 0.519425 10.2395 0.518298 10.235 0.517171L10.2174 0.512662C10.2121 0.511159 10.2072 0.510032 10.202 0.508905C10.1963 0.507778 10.1911 0.507026 10.1854 0.506275L10.1655 0.503269C10.1621 0.502517 10.1584 0.502142 10.155 0.501766C10.1227 0.49876 10.0904 0.49876 10.0584 0.501766C10.0547 0.501766 10.0513 0.502893 10.0475 0.503269L10.0276 0.506275C10.022 0.507026 10.0167 0.507778 10.0111 0.508905C10.0058 0.510032 10.001 0.511159 9.9957 0.512662L9.97804 0.517171C9.97353 0.518298 9.96902 0.519425 9.96489 0.520552C9.96001 0.522055 9.95475 0.523934 9.94986 0.525812L9.93408 0.531448C9.9292 0.532951 9.92469 0.53483 9.9198 0.536708C9.91529 0.538587 9.91079 0.540841 9.90665 0.54272L9.89125 0.549859C9.88636 0.552113 9.88148 0.554367 9.87659 0.556997C9.87246 0.559252 9.8687 0.561506 9.86495 0.56376L9.84954 0.572778C9.84503 0.575408 9.84015 0.578038 9.83564 0.581419C9.83076 0.584801 9.82625 0.588182 9.82174 0.591564L9.80558 0.603587C9.80258 0.605465 9.79995 0.60772 9.79694 0.609974C9.78417 0.620494 9.77214 0.63139 9.76087 0.642286L7.35625 3.04691C7.16576 3.2374 7.16576 3.54737 7.35625 3.73749C7.54674 3.92798 7.85671 3.92798 8.04683 3.73749L9.61772 2.16659V13.0107C9.61772 13.2801 9.83677 13.4991 10.1062 13.4991C10.3756 13.4991 10.5946 13.2801 10.5946 13.0107V2.16734L12.1655 3.73824C12.356 3.92873 12.666 3.92873 12.8561 3.73824C13.0466 3.54775 13.0466 3.23778 12.8561 3.04766H12.8568Z" fill="#313131"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_738_10319">
                                        <rect width="12.9996" height="13" fill="white" transform="translate(0 0.5)"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </template>
                            </span>
                        </th>
                    </template>
                </thead>
                <tbody>
                    <template v-for="record of dataSet">
                        <tr v-if="record['_hidden'] !== true" :key="record" :class="record._id && record._id.value == highlightedRow && 'highlighted'">
                            <template v-for="(item, key) of columns">
                                <template v-if="record[key] && (key != '_id' || displayId) && !key.includes('token') && key !== 'referralNote' && key !== 'comments'">
                                    <td :key="record[key]" :class="'dt-td dt-td-' + record[key]['display_type'] + ' dt-td-' + key">

                                        <span v-if="record[key]['display_type'] == 'text'" :class="'dt-span dt-span-' + key">{{ record[key]['value'] }}</span>

                                        <span v-else-if="record[key]['display_type'] == 'date'" :class="'dt-span dt-span-date dt-span-' + key">
                                            {{ this.formatDate(record[key]['value']) }}
                                        </span>

                                        <span v-else-if="record[key]['display_type'] == 'html'" :class="'dt-span dt-span-' + key" v-html="record[key]['value']">
                                        </span>

                                        <span v-else-if="record[key]['display_type'] == 'image'" :class="'dt-span dt-span-' + key">
                                            <img :src="record[key]['value']" height="40" />
                                        </span>

                                        <span v-else-if="record[key]['display_type'] == 'libraries'" :class="'dt-span dt-span-' + key">
                                            <a href="javascript:;" v-on:click="actionTriggered('libraries', record['_id']['value'], record)">
                                                {{ record[key]['value'].length }} libraries
                                            </a>
                                        </span>

                                        <span v-else-if="record[key]['display_type'] == 'devices'" :class="'dt-span dt-span-' + key">
                                            <span v-if="record[key]['value'].length === 0">0 devices</span>
                                            <a v-else href="javascript:;" v-on:click="actionTriggered('devices', record['_id']['value'], record)">
                                                {{ record[key]['value'].length }} devices
                                            </a>
                                        </span>

                                        <span v-else-if="record[key]['display_type'] == 'object'" :class="'dt-span dt-span-' + key">
                                            <span>
                                                <a href="javascript:;" v-on:click="showObject(record[key]['value'])">
                                                    {{ record[key].hyper_label || 'Info' }}
                                                </a>
                                            </span>
                                        </span>

                                        <span v-else-if="record[key]['display_type'] == 'array'" :class="'dt-span dt-span-' + key">
                                            <span>
                                                <a href="javascript:;" v-on:click="showObject(record[key]['value'])" v-if="record[key].value?.length" :title="record[key].value?.toString()">
                                                    <span>{{ record[key]['value'].length}}</span> Items
                                                </a>
                                            </span>
                                        </span>

                                        <span v-else-if="record[key]['display_type'] == 'actions'" :class="'dt-span dt-span-' + key">
                                            <span v-for="(i, k) of record[key]['value']" :key="k" :class="'dt-action dt-action-' + k">
                                                <a href="javascript:;" >
                                                    <span class="action" v-on:click="actionTriggered(k, record['_id']['value'], record)" v-html="i"></span>
                                                </a>&nbsp;&nbsp;
                                            </span>
                                        </span>

                                        <span v-else :class="'dt-span dt-span-' + key">
                                            ***
                                        </span>

                                    </td>
                                </template>
                                <template v-else-if="(key != '_id' || displayId) && !key.includes('token') && key !== 'referralNote' && key !== 'comments'">
                                    <td :key="record[key]" class="dt-td dt-td-unknown dt-td-unknown"></td>
                                </template>
                            </template>
                        </tr>
                    </template>
                </tbody>
            </table>
            <div v-else class="empty-datatable">
                <slot name="empty"></slot>
            </div>
        </div>

        <div class="pagination" v-if="pagesNum > 1">
            <a href="javascript:;" v-for="currentPage in [...Array(pagesNum).keys()]" class="pagination__page-link"
                    :class="currentPage+1 == page && 'active'"
                    :key="currentPage" v-on:click="goToPage(currentPage+1)">{{ currentPage+1 }}</a>
        </div>

        <div class="results-counter" v-if="totalCount > 0">
            Showing results
            {{ (page - 1) * resultsPerPage + 1 }}
            to
            {{ (page - 1) * resultsPerPage + dataSet.length }}
        </div>

        <OverlayModal v-if="modalOpen"
                :title="modalTitle"
                :closeText="closeModalText"
                @modalClosed="closeModal">

            <div v-for="item of librariesToShow" :key="item">
                <span style="display: inline-block; margin-bottom:12px; line-height: 1rem;">{{ item.name }}</span>
            </div>
        </OverlayModal>

        <OverlayModal v-if="objectModalOpen"
                title=""
                :closeText="closeModalText"
                @modalClosed="closeModal">

            <div v-for="(objValue, objKey) in objectToShow" :key="objKey">
                <span>{{ objKey }}</span>: <span>{{ objValue }}</span>
            </div>
        </OverlayModal>
    </div>
</template>

<script>
import OverlayModal from '@/components/global/OverlayModal'

export default {
    name: 'DataTable',
    props: ['dataUrl', 'displayId', 'dataFormatter', 'filterData', 'sortable', 'highlightedRow', 'filters', 'filterText', 'predefinedFilters'],
    emits: ['actionTriggered'],
    components: {
        OverlayModal
    },
    data: function() {
        return {
            isLoading: true,

            page: 1,
            pagesNum: 1,
            totalCount: 0,
            resultsPerPage: 500,

            sortBy: '',
            sortDirection: 1, //1 or -1

            dataSet: [], //array of objects, objects in format key: value
            columns: {}, //key: label format

            filtersData: this.predefinedFilters ?? {},
            filtersRefreshKey: null,

            modalOpen: false,
            modalTitle: '',
            librariesToShow: [],
            closeModalText: 'Close',

            objectModalOpen: false,
            objectToShow: {},

            nonSortableColumns: ['', '_id', 'icon', 'actions', 'libraries', 'contact', 'devices',
                  'level', 'skus', 'tags'],

            cancelToken: this.axios.CancelToken,
            cancelSource: undefined
        }
    },
    async created() {
        if (localStorage.getItem('sortBy')) {
            this.sortBy = localStorage.getItem('sortBy')
            this.sortDirection = localStorage.getItem('sortDirection') ?? 1
        }
        if (await this.fetchData()) {
            this.isLoading = false
        }
        if (this.filterData) {
            this.filterRecords(this.filterData)
        }
    },
    mounted() {

    },
    watch: {
        filterData: {
            deep: true,
            handler(newValue) {
                this.filterRecords(newValue)
            }
        },
        async filterText() {
            this.isLoading = true
            await this.fetchData()
            this.isLoading = false
        }
    },
    methods: {
        async filterChanged(e) {
            this.filtersData[e.target.name] = e.target.value
            this.isLoading = !await this.fetchData();
        },
        async resetFiltersData() {
            this.filtersData = {}
            this.isLoading = true
            this.filtersRefreshKey = Date.now()

            if (await this.fetchData()) {
                this.isLoading = false
            }
        },
        async fetchData() {
            //fetch data
            //populate dataset and columns
            let finalUrl = this.dataUrl
            finalUrl += '?page=' + this.page + '&resultsPerPage=' + this.resultsPerPage
            finalUrl += '&sortBy=' + this.sortBy + '&sortDirection=' + this.sortDirection
            if (this.filterText) {
                finalUrl += '&search=' + this.filterText
            }

            for (let key in this.filtersData) {
                const filterVal = this.filtersData[key]
                if (Array.isArray(filterVal) && filterVal.length > 0) {
                    for (let arrayVal of filterVal) {
                        finalUrl += '&' + key +'=' + arrayVal
                    }
                }
                else if (filterVal !== '') {
                    finalUrl += '&' + key +'=' + filterVal
                }
            }

            try {
                if (this.cancelSource) {
                    this.cancelSource.cancel('Operation cancelled due to new request')
                }
                this.cancelSource = this.cancelToken.source()
                const response = await this.axios.get(finalUrl, {
                    cancelToken: this.cancelSource.token
                })

                if (this.dataFormatter) {
                    this.setData(this.dataFormatter(response.data.data), 1)
                }
                else {
                    this.setData(response.data.data, 1)
                }
                return true
            }
            catch(error) {
                console.log(error)
                return false
            }
        },
        getDataColumns(rowsData) {

            var finalColumns = {}
            for (var row of rowsData) {
                var newColumns = {}
                for (var fieldKey in row) {
                    //if (fieldKey != '_id' || this.displayId) {
                    //if (row[fieldKey]['display_type'] !== 'hidden') {
                        newColumns[fieldKey] = row[fieldKey]['label']
                    //}
                }

                //merge objects while retaining order
                var mergedColumns = {}
                for (var i in finalColumns) {
                    //pointing at key i
                    var currentSegment = {} //everything in new columns until i column
                    var iIsFound = false

                    for (var j in newColumns) {
                        //look for i column in newColumns
                        currentSegment[j] = newColumns[j]

                        if (i == j) {
                            //take everything until j
                            mergedColumns = { ...mergedColumns, ...currentSegment }
                            currentSegment = {}
                            delete newColumns[i]
                            iIsFound = true
                            break
                        }
                    }

                    if (!iIsFound) {
                        mergedColumns[i] = finalColumns[i]
                    }
                }

                //add remaining (new) items in newColumns if not all found and removed
                if (Object.keys(newColumns).length > 0) {
                    mergedColumns = { ...mergedColumns, ...newColumns}
                }

                finalColumns = mergedColumns
            }

            //console.log(finalColumns)
            return finalColumns
        },
        setData(rowsData, totalCount) {
            //console.log(rowsData)
            var data = []
            const activatedColumns = this.getDataColumns(rowsData)

            for (var row of rowsData) {
                var currentData = {}
                for (var key in activatedColumns) {
                    currentData[key] = row[key]
                }
                data.push(currentData)
            }

            //temporary solution -- add actions last until we have column sorting
            /*
            if (activatedColumns['actions'] !== undefined) {
                const actionsLabel = activatedColumns['actions']
                delete activatedColumns['actions']
                activatedColumns['actions'] = actionsLabel
            }
            */

            this.dataSet = data
            this.pagesNum = Math.ceil(totalCount / this.resultsPerPage)
            this.totalCount = totalCount
            this.columns = activatedColumns
        },
        filterRecords(filterData) {
            for (let i in this.dataSet) {
                const row = this.dataSet[i]
                this.dataSet[i]['_hidden'] = false
                for (let key in filterData) {
                    if (filterData[key]) {
                        if (key == '*') {
                            let matchFound = false
                            for (let column in this.columns) {
                                //const type = row[column]['display_type']
                                //if (type == 'text' || type == 'date' || type == 'html') {
                                    if (row[column] && row[column]['value'] &&
                                            row[column]['value'].toString().toLowerCase().includes(filterData[key].toLowerCase())) {
                                        matchFound = true
                                        break
                                    }
                                //}
                            }
                            //console.log(matchFound)
                            if (!matchFound) {
                                this.dataSet[i]['_hidden'] = true
                            }
                        }
                        else if (row[key]) {
                            //const type = row[key]['display_type']
                            //if (type === 'text' || type === 'date' || type === 'html') {
                                if (!row[key] || !row[key]['value'] ||
                                    !row[key]['value'].toString().toLowerCase().includes(filterData[key].toLowerCase())) {
                                    this.dataSet[i]['_hidden'] = true
                                    break
                                }
                            //}
                        }
                    }
                }
            }
        },
        showLibraries(librariesArray) {
            //console.log(librariesArray)
            this.librariesToShow = librariesArray
            this.modalOpen = true
        },
        showObject(obj) {
            this.objectToShow = obj
            this.objectModalOpen = true
        },
        closeModal() {
            this.filesToShow = []
            this.modalOpen = false

            this.objectToShow = {}
            this.objectModalOpen = false
        },
        async sortByColumn(key) {
            if (this.sortable && key !== 'actions' && key !== 'icon' && key !== '') {
                if (this.sortBy == key) {
                    this.sortDirection = -1 * this.sortDirection
                }
                else {
                    this.sortBy = key
                    this.sortDirection = 1
                }
                this.isLoading = true
                await this.fetchData()
                this.isLoading = false
                localStorage.setItem('sortBy', key)
                localStorage.setItem('sortDirection', this.sortDirection)
            }
        },
        goToPage(page) {
            this.page = page
            this.fetchData()
        },

        actionTriggered(actionType, identifier, obj = null) {
            this.$emit('actionTriggered', actionType, identifier, obj)
        }
    }
}
</script>

<style lang="scss" scoped>
.filters-section {
    display: flex;
    flex-flow: row;
    gap: 10px;
    margin-bottom: 20px;
    align-items: center;
}
.filter-item {
    select, input {
        width: 200px;
    }
}

.data-table-component {
    padding-right: 5px;
    margin-right: -5px;
    padding-bottom: 5px;
    width: 100%;
    box-sizing: content-box;
    direction: ltr;
    overflow: scroll;

    /*
    & > * {
        direction: rtl;
    }
    */
}

.outer {
    position:relative;
	max-width: 100%;
    overflow-y: visible;
    overflow-x: visible;
}

.inner {
    /*
    width:100%;
	overflow-x: visible;
    overflow-y: visible;
    padding-left: 100px;
    box-sizing: border-box;
    */
    width: fit-content;
    min-width: 100%;
}
.data-table {
    width: auto;
    min-width: 100%;
    border-collapse: separate;
    border-spacing: 0px 10px;
    margin-top: -10px;
    overflow: visible;

    th:first-child, td:first-child {
        border-start-start-radius: 10px;
        border-end-start-radius: 10px;
    }
    th:last-child, td:last-child {
        border-start-end-radius: 10px;
        border-end-end-radius: 10px;

        /*
        width: 100px;
        position: absolute;
        left: 0;
        display: flex;
        align-items: center;
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.15);
        */
    }
    th {
        border: 0;
        background-color: $white-color;
        height: 35px;
        box-sizing: border-box;
        padding: 5px 15px;
        color: $black-color;
        text-align: right;
        font-weight: $font-weight-bold;

        &.fixed {
            position: absolute;
            left: 0;
        }

        .th-inner {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            gap: 9px;

            &.sortable {
                cursor: pointer;
            }
        }
    }
    td {
        border: 0;
        background: $white-color;
        box-sizing: border-box;
        height: 65px;
        box-sizing: border-box;
        padding: 5px 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 24px;
        color: $text-color;
        white-space: nowrap;
        min-width: 50px;
        max-width: 700px;

        transition: background .5s !important;

        &.fixed {
            position: absolute;
            left: 0;
        }
    }
    .dt-td-date {

    }
    .dt-span-actions {
        margin: auto 0;
    }

    tr.highlighted {
        td {
            transition: background .3s;
            background: #d3e6b6;
        }
    }
}

.dt-td-actions {
    text-align: right;
    padding-left: 25px;

    .dt-span-actions {
        margin: auto 0;
    }
}

.empty-datatable {
    display: block;
    background: $white-color;
    border-radius: $default-border-radius;
    padding: 15px;
    font-size: $font-size;
    color: $text-color;
    line-height: $line-height;

    p {
        margin: 0;
        padding: 0;
    }
}
</style>
